import React, { useEffect } from 'react';
import {
  isAuthShellRoute,
  isPendingSecondFactorActive,
} from '../features/two-factor-auth/utils/pendingSecondFactorSession';

const ReloadPrompt = () => {
  useEffect(() => {
    const checkVersion = () => {
      if (isAuthShellRoute() || isPendingSecondFactorActive()) {
        return;
      }
      const currentVersion = localStorage.getItem('appVersion');
      const lastVersion = localStorage.getItem('lastVersion');
      
      // Automatically refresh if versions don't match
      if (currentVersion && lastVersion && currentVersion !== lastVersion) {
        console.log('Version mismatch detected, automatically refreshing...');
        localStorage.setItem('lastVersion', currentVersion);
        window.location.reload(true);
      } else if (currentVersion && !lastVersion) {
        // Initialize lastVersion if it doesn't exist
        localStorage.setItem('lastVersion', currentVersion);
      }
    };

    // Initial check
    checkVersion();

    const interval = setInterval(checkVersion, 60000);
    return () => clearInterval(interval);
  }, []);

  // No need to render anything since we're auto-refreshing
  return null;
};

export default ReloadPrompt;
